import { CodeSurfer, CodeSurferColumns, Step } from "code-surfer";
import { theme1, theme2 } from "../../../../../../docs/slides/controlled/custom-theme";
import { InputDemo, ButtonDemo, FieldDemo } from "../../../../../../docs/slides/controlled/widgets";
import React from 'react';
export default {
  CodeSurfer: CodeSurfer,
  CodeSurferColumns: CodeSurferColumns,
  Step: Step,
  theme1: theme1,
  theme2: theme2,
  InputDemo: InputDemo,
  ButtonDemo: ButtonDemo,
  FieldDemo: FieldDemo,
  React: React
};